import {
  ButtonUnderline,
  Heading,
  Stack,
  Text,
} from '@global-ecom/nitro-uds/elements';

import { usePdp } from 'hooks/usePdp';
import { useTranslate } from 'hooks/useTranslations';
import { scrollTo } from 'utils/scroll-to';
import { SafeHtml } from 'ui/elements/SafeHtml';
import { usePageEventsContext } from 'hooks/usePageEventsContext';
import {
  AnalyticsEvents,
  addPrefixToAnalyticProp,
  event,
} from 'utils/analytics';
export const ProductDescription = () => {
  const translate = useTranslate();
  const { masterProduct, variation } = usePdp();
  const { pageviewEventHasFired } = usePageEventsContext();

  if (!masterProduct?.description) return null;

  const triggerEventAndScrollTo = () => {
    scrollTo('product-story', -70);
    if (pageviewEventHasFired && variation)
      event(AnalyticsEvents.GA4_CustomEvent, {
        event_name: AnalyticsEvents.MORE_INFORMATION,
        event_params: {
          item_id_ep: variation?.id,
          item_name_ep: variation?.name,
          color_code_ep: addPrefixToAnalyticProp(variation?.colorValue),
          style_number_ep: variation?.styleNumber,
        },
      });
  };
  return (
    <Stack gap="sm" data-test-id="pdp-product-description" className="pb-4">
      <Heading asChild size="sm" weight="bold">
        <h2>{translate('description')}</h2>
      </Heading>
      <Text asChild>
        <SafeHtml
          // original css that added ellipsis, but created an overflow bug in Safari
          // add back at risk of a regression.
          // style={{
          //   display: '-webkit-box',
          //   WebkitLineClamp: 2,
          //   WebkitBoxOrient: 'vertical',
          //   overflow: 'hidden',
          // }}
          // ellipsis does not work with this method but everything else looks good.
          style={{
            lineHeight: '1.5em',
            height: '3em',
            overflow: 'hidden',
            width: '100%',
            textOverflow: 'ellipsis',
          }}
          html={variation?.description || masterProduct.description}
        />
      </Text>
      <Text asChild>
        <ul className="list-disc list-inside">
          <li>
            {translate('style')}: {variation?.id}
          </li>
          <li>
            {translate('color')}: {variation?.colorName}
          </li>
        </ul>
      </Text>
      <ButtonUnderline
        dataTestId="read-more-btn"
        transform="uppercase"
        size="sm"
        className="mt-2"
        onClick={() => triggerEventAndScrollTo()}
        label={translate('additionalInfo')}
      />
    </Stack>
  );
};
